import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { LargeButton, ButtonType } from '@checkmarx/cx-ui';
import classNames from 'classnames';

const queryString = require('query-string');
import PortalTextBox from '../../../portal/portalTextBox';
import ValidationTopErrorMessage from '../../../portal/controls/validationTopErrorMessage';
import RestrictionsTooltip from '../../../portal/controls/restrictionsTooltip/restrictionsTooltip';
import styles from './style.scss';

@inject('translationsStore', 'resetPasswordStore', 'configurationsStore','passwordPoliciesStore') @observer
export default class ResetPasswordForm extends Component {

    componentWillUnmount() {

        this.props.resetPasswordStore.reset();
    }

    componentDidMount() {

        const { token = '' } = queryString.parse(window.location.search);

        this.props.resetPasswordStore.setToken(token);
        const { tenant = '' } = queryString.parse(window.location.search);
        this.props.passwordPoliciesStore.updatePasswordPolicies(tenant);
    }

    handleUserNameChange = e => this.props.resetPasswordStore.setUserName(e.target.value);
    handleUserNameOnBlur = e => this.props.resetPasswordStore.validateUserName();

    handleTenantChange = e => this.props.resetPasswordStore.setTenant(e.target.value);
    handleTenantOnBlur = e => this.props.resetPasswordStore.validateTenant();

    handlePasswordChange = e => {
        this.props.resetPasswordStore.setPassword(e.target.value);
        this.props.resetPasswordStore.validatePassword();
    };

    handleSubmitForm = (e) => {

        e.preventDefault();

        this.props.resetPasswordStore.isLoginError = false;
        this.props.resetPasswordStore.loginErrorMessage = '';

        const isValid = this.props.resetPasswordStore.validateForm();

        if (isValid === false) {

            return;
        }

        this.props.resetPasswordStore.resetPassword().then(() => {

            this.props.handleResetPassword();
        });
    };

    render() {

        const {
            values, inProgress, tenantValidationMessage, resetPasswordErrorMessage,
            passwordValidationMessage, userNameValidationMessage, resetPasswordProgress
        } = this.props.resetPasswordStore;

        const { isMultitenancyMode } = this.props.configurationsStore;

        const passwordErrorUnderlineColor = values.password && (passwordValidationMessage || []).length && '#F1605D';
        const tenantField = isMultitenancyMode ? (
            <div>
                <PortalTextBox
                    id="txtTenant"
                    dataCy="tenant"
                    hintText={ this.props.translationsStore.translate('ACCOUNT') }
                    floatingLabelText={ this.props.translationsStore.translate('ACCOUNT') }
                    disabled={ inProgress }
                    onChange={ this.handleTenantChange }
                    onBlur={ this.handleTenantOnBlur }
                    errorText={ tenantValidationMessage }
                    value={ values.tenant }
                    ref="tenant" />
            </div>
        ) : null;

        return (
            <div className="login-form reset-password">
                <form onSubmit={ this.handleSubmitForm } className="form">
                    <div className={ classNames(styles.errorMessageWrapper) } style={ { marginBottom: '15px' } }>
                        <ValidationTopErrorMessage errorMessage={ resetPasswordErrorMessage } />
                    </div>

                    <div className={ classNames(styles.titleWrapper) }>
                        <span>
                            { this.props.translationsStore.translate('ENTER_A_NEW_PASSWORD') }
                        </span>
                    </div>

                    <div style={ { width: '335px' } }>
                        { tenantField }

                        <div>
                            <PortalTextBox
                                hintText={ this.props.translationsStore.translate('USER_NAME') }
                                floatingLabelText={ this.props.translationsStore.translate('USER_NAME') }
                                disabled={ inProgress }
                                onChange={ this.handleUserNameChange }
                                onBlur={ this.handleUserNameOnBlur }
                                errorText={ userNameValidationMessage }
                                value={ values.userName } />
                        </div>

                        <div>
                            <PortalTextBox
                                hintText={ this.props.translationsStore.translate('CREATE_PASSWORD') }
                                floatingLabelText={ this.props.translationsStore.translate('CREATE_PASSWORD') }
                                underlineColor={ passwordErrorUnderlineColor }
                                underlineFocusColor={ passwordErrorUnderlineColor }
                                includeContentVisibilityToggle
                                triggerHelpTooltipOnFocus
                                helpTooltipPlacement="right"
                                helpTooltipText={
                                    <RestrictionsTooltip isInputPristine={ Boolean(values.password) }
                                        restrictions={this.props.passwordPoliciesStore.PasswordRestrictions}
                                                         failingRestrictions={ passwordValidationMessage || [] } />
                                }
                                disabled={ inProgress }
                                onChange={ this.handlePasswordChange }
                                type="password"
                                value={ values.password } />
                        </div>
                    </div>

                    <div>
                        <LargeButton
                            type="submit"
                            id="btnUpdatePasswordSubmit"
                            dataCy="update-password-button"
                            inProgress={ resetPasswordProgress }
                            text={ this.props.translationsStore.translate('SAVE') }
                            style={ { marginTop: '30px', width: '335px' } }
                            disabled={ this.props.requireEula && !values.eulaAccepted } />
                    </div>
                </form>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/account/forgotPasswordFlow/resetPasswordForm/index.jsx